var route = {
    path : '/OAuth/google',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            cb(null, require('../pc/components/ThirdPartyOAuth/OAuth.jsx').default)
        }, 'OAuth-ThirdParty')
    }
}


export default route;



// WEBPACK FOOTER //
// ./src/routes/OAuthGoogle.js